/**
 * @component 组件详情页
 * @description 用于展示应用/插件的详细信息，包括商品信息、使用说明，以及购买流程（含二维码支付和0元购）
 * 
 * @data {string} id - 当前版本ID，从路由参数获取
 * @data {Object} infoData - 商品详情数据，包含 name、desc、icon、show_icon、price、original_price、details、is_permission 等字段
 * @data {boolean} moneyModal - 购买弹窗的显示状态
 * @data {string} qrcodeData - 支付二维码链接
 * @data {string} order_id - 当前订单ID
 * @data {number|null} timer - 轮询支付状态的定时器ID
 * @data {boolean} loading - 二维码加载状态
 * @data {string} apps_id - 应用ID，从路由参数获取
 * 
 * @method getInfo - 根据版本ID获取商品详情信息
 * @method goBuy - 发起购买操作，显示加载状态并调用支付接口
 * @method getAppsBuy - 调用购买接口，处理0元购和二维码支付两种场景
 * @method goVersionQuery - 轮询查询订单支付状态，支付成功后刷新商品信息
 * @method startInterval - 启动5秒间隔的定时器，轮询支付状态
 * @method clearInterval - 清除支付状态轮询定时器
 * @method goCancelMoneyModal - 关闭购买弹窗并清除定时器
 * 
 * @lifecycle mounted - 从路由参数中获取 title、id、apps_id，并加载商品详情
 * @lifecycle beforeDestroy - 组件销毁前清除定时器，防止内存泄漏
 */
<!-- 组件详情 -->
<template>
    <div class="container">
        <div class="title">商品信息</div>
        <div class="card">
            <img
                v-if="infoData.icon"
                :src="infoData.show_icon"
                class="card-icon"
            />
            <div class="card-right">
                <div class="card-title">{{ infoData.name }}</div>
                <div v-if="infoData.desc">
                    {{ infoData.desc }}
                </div>
            </div>
            <template v-if="infoData.name">
                <Button
                    v-if="!infoData.is_permission"
                    class="theme-bc theme-default-color btn-buy"
                    @click="goBuy"
                    >去购买</Button
                >
            </template>
        </div>
        <div v-if="infoData.details">
            <div class="title mt24">使用说明</div>
            <div class="content">
                <div v-dompurify-html="infoData.details"></div>
            </div>
        </div>

        <!-- 购买插件 -->
        <Modal
            v-model="moneyModal"
            title="购买插件"
            width="700"
            @on-cancel="goCancelMoneyModal"
        >
            <div class="money-container">
                <div class="title">商品信息</div>
                <div class="card">
                    <img
                        v-if="infoData.icon"
                        :src="infoData.show_icon"
                        class="card-icon"
                    />
                    <div class="card-right">
                        <div class="card-title">{{ infoData.name }}</div>
                        <div v-if="infoData.desc">
                            {{ infoData.desc }}
                        </div>
                    </div>
                </div>
                <div class="title mt24">应支付金额</div>
                <div class="price-container">
                    <div class="mr36">
                        <div class="money-title">￥{{ infoData.price }}</div>
                        <div v-if="infoData.original_price">
                            原价￥{{ infoData.original_price }}
                        </div>
                    </div>
                    <div class="qrcode-container">
                        <img
                            v-if="loading"
                            src="@/assets/loading.gif"
                            alt="加载中"
                            class="loading-img-container"
                        />
                        <VueQr
                            v-else-if="qrcodeData"
                            id="vueQr"
                            :text="qrcodeData"
                        ></VueQr>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template> 

<script>
import { apps_info, apps_buy, version_query } from "@/api/index";
import VueQr from "vue-qr";
export default {
    components: { VueQr },
    data() {
        return {
            id: "",
            infoData: {},
            moneyModal: false,
            qrcodeData: "",
            order_id: "",
            timer: null, // 存储定时器ID
            loading: false,
            apps_id: "",
        };
    },
    mounted() {
        if (this.$route.query.title) {
            this.$route.meta.title = this.$route.query.title;
        }
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.getInfo();
        }
        if (this.$route.query.apps_id) {
            this.apps_id = this.$route.query.apps_id;
        }
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        this.clearInterval();
    },
    methods: {
        getInfo() {
            apps_info({ id: this.id }).then((res) => {
                this.infoData = res.data;
            });
        },
        goBuy() {
            this.loading = true;
            this.getAppsBuy();
        },
        getAppsBuy() {
            const data = {
                version_id: this.infoData.id,
                pay_type: 1,
            };
            apps_buy(data)
                .then((res) => {
                    // 0元购
                    if (res.data && res.data.code && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                        setTimeout(() => {
                            this.getInfo();
                        }, 1000);
                        return;
                    }
                    this.qrcodeData = res.data.data;
                    this.order_id = res.data.order_id;
                    setTimeout(() => {
                        this.loading = false;
                    }, 300);
                    this.startInterval();
                    this.moneyModal = true;
                })
                .catch((err) => {
                    this.qrcodeData = "";
                    const errorMsg =
                        (err && err.msg) ||
                        (err && err.message) ||
                        "加载二维码失败，请刷新重试";
                    this.$Message.error(errorMsg);
                });
        },
        goVersionQuery() {
            version_query({ order_id: this.order_id })
                .then((res) => {
                    // 0 未付款 1 付款成功
                    if (res.data == 1) {
                        this.$Message.success("支付成功");
                        this.moneyModal = false;
                        this.clearInterval();
                        setTimeout(() => {
                            this.getInfo();
                        }, 1000);
                    }
                })
                .catch((err) => {
                    console.error("支付状态查询失败:", err);
                });
        },
        // 启动定时器
        startInterval() {
            this.timer = setInterval(() => {
                this.goVersionQuery();
            }, 5000);
        },
        // 清除定时器
        clearInterval() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        goCancelMoneyModal() {
            this.clearInterval();
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px 36px;
    min-height: 400px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    margin-bottom: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
}
.card {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.card-icon {
    margin-right: 12px;
    width: 58px;
    height: 58px;
}
.card-right {
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
}
.card-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
}
.content {
    margin-left: 24px;
}
.btn-buy {
    margin-left: 36px;
    border-radius: 10px;
}
.money-container {
    margin: 24px 36px;
}
.price-container {
    margin-left: 24px;
    display: flex;
}
.money-title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #de0000;
}
.money-txt {
    margin-left: 6px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    font-size: 14px;
    color: #999999;
    text-decoration-line: line-through;
}
.mr36 {
    margin-right: 36px;
}
.qrcode-container {
    margin-top: -36px;
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
}
.loading-img-container {
    width: 50px;
    height: 50px;
}
</style>